export const READ_LIST = `LISTS/READ_LIST`
export const READ_LIST_SUCCEEDED = `LISTS/READ_LIST_SUCCEEDED`
export const READ_LIST_FAILED = `LISTS/READ_LIST_FAILED`

export const UPDATE_LIST = `LISTS/UPDATE_LIST`
export const UPDATE_LIST_SUCCEEDED = `LISTS/UPDATE_LIST_SUCCEEDED`
export const UPDATE_LIST_FAILED = `LISTS/UPDATE_LIST_FAILED`

export const REMOVE_LIST_ITEM = `LISTS/REMOVE_LIST_ITEM`
export const REMOVE_LIST_ITEM_SUCCEEDED = `LISTS/REMOVE_LIST_ITEM_SUCCEEDED`
export const REMOVE_LIST_ITEM_FAILED = `LISTS/REMOVE_LIST_ITEM_FAILED`
